var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('BackPage'),(_vm.info)?[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.info.title)+" ")]),_c('div',{staticClass:"time"},[_vm._v(" "+_vm._s(_vm.formatDate(_vm.info.date))+" ")]),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.info.content)+" ")])]:[_c('nomsg')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }